import React, { useState } from "react";
import {
  Box, Button, FormControl, FormLabel, Input, Heading, Stack,
  useToast, Flex, Text, InputGroup, InputRightElement, IconButton,
  Container, Center, VStack
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import LoginRequest from "../../services/models/LoginRequest";
import LoginResponse from "../../services/models/LoginResponse";
import ApiResponse from "../../services/ApiResponse";

const LoginPage = () => {
  const [formData, setFormData] = useState<LoginRequest>({ correo: "", clave: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  const toast = useToast();
  const navigate = useNavigate();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Limpiamos toasts previos antes de intentar
    toast.closeAll();

    const apiResponse = new ApiResponse<LoginResponse>();
    await apiResponse.useFetch("usuarios/login", "POST", formData);

    if (apiResponse.data) {
      toast({
        title: "¡Bienvenido!",
        description: "Inicio de sesión exitoso.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      localStorage.setItem("token", apiResponse.data.token);
      navigate("/dashboard", { replace: true });
    } else {
      toast({
        title: "Error de acceso",
        description: "Correo o contraseña incorrectos.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
    setIsLoading(false);
  };

  return (
    <Box 
      bgGradient="linear(to-br, blue.800, #0a192f)" 
      minH="100vh" 
      display="flex" 
      alignItems="center" 
      justifyContent="center"
    >
      <Container maxW="md">
        <Box
          p={8}
          bg="rgba(255, 255, 255, 0.05)"
          backdropFilter="blur(15px)"
          border="1px solid"
          borderColor="whiteAlpha.200"
          borderRadius="3xl"
          boxShadow="2xl"
        >
          <VStack spacing={6} align="stretch">
            <VStack spacing={2} textAlign="center" mb={4}>
              <Heading color="white" size="xl" fontWeight="black">
                Goya Estudia
              </Heading>
              <Text color="whiteAlpha.600">Ingresá a tu panel de administración</Text>
            </VStack>

            <form onSubmit={handleSubmit}>
              <Stack spacing={5}>
                <FormControl id="correo" isRequired>
                  <FormLabel color="whiteAlpha.800" fontSize="sm">Correo Electrónico</FormLabel>
                  <Input
                    type="email"
                    placeholder="nombre@ejemplo.com"
                    bg="whiteAlpha.100"
                    border="none"
                    color="white"
                    _focus={{ ring: 2, ringColor: "#E9681F" }}
                    value={formData.correo}
                    onChange={handleInputChange}
                  />
                </FormControl>

                <FormControl id="clave" isRequired>
                  <FormLabel color="whiteAlpha.800" fontSize="sm">Contraseña</FormLabel>
                  <InputGroup>
                    <Input
                      type={showPassword ? "text" : "password"}
                      placeholder="••••••••"
                      bg="whiteAlpha.100"
                      border="none"
                      color="white"
                      _focus={{ ring: 2, ringColor: "#E9681F" }}
                      value={formData.clave}
                      onChange={handleInputChange}
                    />
                    <InputRightElement>
                      <IconButton
                        variant="ghost"
                        color="whiteAlpha.600"
                        _hover={{ color: "white" }}
                        icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                        onClick={() => setShowPassword(!showPassword)}
                        aria-label="Ver contraseña"
                      />
                    </InputRightElement>
                  </InputGroup>
                </FormControl>

                <Button
                  type="submit"
                  bg="#E9681F"
                  color="white"
                  size="lg"
                  fontSize="md"
                  fontWeight="bold"
                  isLoading={isLoading}
                  _hover={{ bg: "#d15a1a", transform: "translateY(-2px)" }}
                  _active={{ transform: "translateY(0)" }}
                  transition="all 0.2s"
                  borderRadius="xl"
                  mt={4}
                >
                  Iniciar Sesión
                </Button>
              </Stack>
            </form>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};
export default LoginPage;